module.exports = __webpack_public_path__ + "img/forward.b1c0850e.svg";